import { createApp } from 'vue'
import options from './PreFooter.options'

const el = '.kb-component--pre-footer'

export default function (Store) {
    const DOM = document.querySelector(el)
    if (DOM) {
        if (DOM.hasAttribute('data-v-app')) return false
        const template = DOM.outerHTML
        options.template = template
        const component = createApp(options).use(Store)
        component.mount(el)
    }
}
